module.exports = __webpack_public_path__ + "static/media/CabinetInterior_After.b2fd4567.jpg";